import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import DatasetsListView from "./datasets-list.html";
import DatasetsEditView from "./datasets-edit.html";
import DatasetsExportView from "./datasets-export.html";


angular.module("datasets", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('datasets', {
                url: "/datasets",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })

            .state('datasets.list', {
                url: "/list",
                controller: "DatasetsListCtrl",
                template: DatasetsListView,
                cache: false,
                requiredPermission: ["DATASETS_ACCESS"]
            })
            .state('datasets.edit', {
                url: "/edit/:id",
                controller: "DatasetsEditCtrl",
                template: DatasetsEditView,
                cache: false,
                requiredPermission: ["DATASETS_ACCESS"]
            })
            .state('datasets.export', {
                url: "/export/:id",
                controller: "DatasetsExportCtrl",
                template: DatasetsExportView,
                cache: false,
                requiredPermission: ["DATASETS_EXPORT"]
            })
    }])
;